function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["checked", "value", "label", "className", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import PropTypes from "prop-types";
import { RadioButtonChecked as Checked, RadioButtonUnchecked as Unchecked } from "../../icons";
import RadioGroup, { RadioContext, getInputProps } from "./RadioGroup";
import RadioButton from "./RadioButton";
import { onRadioKeyPress } from "../../helpers";
import { useId } from "../../helpers/hooks";
var Radio = function Radio(_ref) {
  var checked = _ref.checked,
    value = _ref.value,
    label = _ref.label,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  var id = useId();
  var labelId = "texada-ui-radio-".concat(id);
  var context = useContext(RadioContext);
  var inputProps = getInputProps(context, _objectSpread({
    checked: checked,
    value: value
  }, props));
  var Icon = inputProps.checked ? Checked : Unchecked;
  return /*#__PURE__*/React.createElement("div", {
    className: "tui-radio ".concat(inputProps.checked ? "checked" : "", " ").concat(className),
    role: "radio",
    "aria-checked": inputProps.checked,
    tabIndex: inputProps.disabled ? -1 : 0,
    disabled: inputProps.disabled,
    onKeyPress: onRadioKeyPress(labelId),
    style: style
  }, /*#__PURE__*/React.createElement("input", _extends({}, inputProps, {
    id: labelId,
    tabIndex: "-1",
    type: "radio"
  })), /*#__PURE__*/React.createElement(Icon, null), label && /*#__PURE__*/React.createElement("label", {
    htmlFor: labelId
  }, label));
};
Radio.propTypes = {
  checked: PropTypes.bool,
  value: PropTypes.any,
  label: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object
};
Radio.Group = RadioGroup;
Radio.Button = RadioButton;
export default Radio;
//# sourceMappingURL=Radio.js.map